/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface EditableState {
  isEditable: boolean;
  isEditing: boolean;
  status: "idle" | "loading" | "failed";
}

const initialState: EditableState = {
  isEditable: false,
  isEditing: false,
  status: "idle",
};
export const editableSlice = createSlice({
  name: "editable",
  initialState,
  reducers: {
    setIsEditable: (state, action: PayloadAction<boolean>) => {
      state.isEditable = action.payload;
    },
    setIsEditing: (state, action: PayloadAction<boolean>) => {
      state.isEditing = action.payload;
    },
  },
});

export const { setIsEditable, setIsEditing } = editableSlice.actions;
export const selectIsEditable = () => (state: RootState) =>
  state.editable.isEditable;
export const selectIsEditing = () => (state: RootState) =>
  state.editable.isEditing;

export default editableSlice.reducer;
